export const SEARCH_RESULTS_LIMIT = 15

export const FREQUENT_MATERIAL_NAMES = [
  "cemento",
  "arena",
  "ladrillo",
  "hierro",
  "cal",
  "yeso",
  "pintura",
  "ceramica",
  "pegamento",
  "bloque",
]

export const ulVariants = {
  hidden: {
    opacity: 0,
    height: 0,
  },
  visible: {
    opacity: 1,
    height: "auto",
    transition: {
      opacity: {
        duration: 0.8,
      },
      height: {
        duration: 0.3,
      },
    },
  },
}
